import { plural, t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { RadixDialog } from '@jotta/ui/RadixDialog'
import type { RadixModalProps } from '@jotta/ui/RadixModal'
import { RadixModal } from '@jotta/ui/RadixModal'
import { TextThemeUI } from '@jotta/ui/themeui'

export interface RemovePhotoDialogProps extends RadixModalProps {
  count?: number
  isLoading?: boolean
  onRemovePhoto: () => void
}

export const RemovePhotoDialog: React.FC<RemovePhotoDialogProps> = ({
  count = 1,
  open = false,
  isLoading = false,
  onClose,
  onRemovePhoto,
  ...props
}) => {
  return (
    <RadixModal open={open} onClose={onClose} {...props}>
      <RadixDialog
        title={plural(count, {
          one: 'Are you sure you want to remove the selected photo?',
          other: 'Are you sure you want to remove the # selected photos?',
        })}
        onClose={onClose}
        buttons={[
          {
            label: t`Remove from album`,
            loading: isLoading,
            action: onRemovePhoto,
            type: 'destructive',
          },
          {
            action: 'close',
            label: t`Cancel`,
            type: 'outline',
          },
        ]}
      >
        <TextThemeUI variant="styles.p" sx={{ mb: 3 }}>
          <Trans>
            The photos you remove will still exist in the timeline of the one
            who added them, they can always be added back later.
          </Trans>
        </TextThemeUI>
      </RadixDialog>
    </RadixModal>
  )
}
